export const passwordConfig = {
  minLength: 12,
  maxLength: 2048,
  minGuessesLog10: 8,
  goodGuessesLog10: 10,
} as const;
